import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { coreRoutes } from '@next/core-lib/app';

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          pathMatch: 'full',
          redirectTo: '/history',
        },
        ...coreRoutes,
      ],
      { initialNavigation: 'enabledNonBlocking' },
    ),
  ],
})
export class AppRoutingModule {}
